import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/mailArchive';

const routes = helper.generateRoutes('mailArchive', selectors, {
    omit: ['create', 'edit']
});

routes.list.list.breadcrumb = 'Archivio richieste di preventivo';

const list = _.values(routes.list).map(route => ({
    ...route,
    hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'mailArchive' */ `modules/mailArchive/${
                route.componentPath
                }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('mailArchive', routes.patterns, {
    it: 'Archivio richieste di preventivo'
});
routeRegister.addLinks('mailArchive', links);

export default list;
